export function currentPageToAnalyticsName() {
  return urlToSection(window.location.pathname);
}

export function urlToSection(url) {
  if (url.match(/\/develop\//)) {
    // Develop pages
    if (url.match(/\/(products\/[^/]+|bookmarks)\/workflow_boards\b/)) {
      return 'Develop: Workflow board';
    } else if (url.match(/\/products\/[^/]+\/iterations\b/)) {
      return 'Develop: Sprint planning';
    } else if (url.match(/\/products\/[^/]+\/backlogs\b/)) {
      return 'Develop: Backlog management';
    } else if (url.match(/\/bookmarks\/velocity_charts\//)) {
      return 'Develop: Velocity';
    } else if (url.match(/\/bookmarks\/throughput_charts\//)) {
      return 'Develop: Throughput';
    } else if (url.match(/\/bookmarks\/cycle_time_charts\//)) {
      return 'Develop: Cycle & lead time';
    } else if (url.match(/\/bookmarks\/product_value_charts\//)) {
      return 'Develop: Product value';
    } else if (url.match(/\/bookmarks\/delivery_risks_charts\//)) {
      return 'Develop: Delivery risks';
    } else if (url.match(/\/bookmarks\/retrospective_reports\//)) {
      return 'Develop: Iteration retrospectives';
    }
  }

  if (url.match(/discovery/)) {
    // Discovery pages
    if (url.match(/\/discovery_interviews/)) {
      return 'Discovery: Interviews';
    } else if (url.match(/\/discovery_scripts/)) {
      return 'Discovery: Scripts';
    } else if (url.match(/\/discovery_insights/)) {
      return 'Discovery: Insights report';
    } else if (url.match(/\/discovery_idea_users/)) {
      return 'Discovery: Participants';
    } else if (url.match(/\/discovery_groups/)) {
      return 'Discovery: Groups';
    } else if (url.match(/\/discovery_organizations/)) {
      return 'Discovery: Organizations';
    } else if (url.match(/\/discovery_schedules/)) {
      return 'Discovery: Schedules';
    } else if (url.match(/\/discovery_calendar/)) {
      return 'Discovery: Calendar';
    } else if (url.match(/\/discovery_messages/)) {
      return 'Discovery: Messages';
    } else if (url.match(/\/discovery_mail_templates/)) {
      return 'Discovery: Automated macros';
    } else if (url.match(/\/discovery_mail_replies/)) {
      return 'Discovery: Manual macros';
    } else if (url.match(/\/discovery_mail_configure/)) {
      return 'Discovery: Macro configuration';
    } else if (url.match(/\/discovery\/reports/)) {
      return 'Discovery: Reports';
    } else if (url.match(/\/discovery_studies/)) {
      return 'Discovery: Studies';
    }
  }

  if (url.match(/\/bookmarks\/roadmaps\//)) {
    return 'Starter roadmap';
  } else if (url.match(/\/releases/)) {
    return 'Releases';
  } else if (url.match(/\/initiatives/)) {
    return 'Initiatives';
  } else if (
    url.match(/\/strategic_imperatives/) ||
    url.match(/\/bookmarks\/strategic_imperatives_charts\//)
  ) {
    return 'Goals';
  } else if (
    url.match(/feature_cards/) ||
    url.match(/\/features/) ||
    url.match(/\/bookmarks\/feature_grids\//)
  ) {
    return 'Features';
  } else if (url.match(/epics/)) {
    return 'Epics';
  } else if (url.match(/\/feature_boards\//)) {
    return 'Workflow';
  } else if (url.match(/personas/)) {
    return 'Personas';
  } else if (url.match(/competitors/)) {
    return 'Competitors';
  } else if (url.match(/creative_briefs/)) {
    return 'Creative briefs';
  } else if (url.match(/\/bookmarks\/strategy_roadmaps/)) {
    return 'Strategy roadmap';
  } else if (url.match(/\/bookmarks\/custom_pivots\//)) {
    return 'Custom roadmap';
  } else if (
    url.match(/\/ideas\//) ||
    url.match(/\/ideas_overview/) ||
    url.match(/\/idea_overviews/) ||
    url.match(/\/bookmarks\/idea_grids\//) ||
    url.match(/\/bookmarks\/idea_priority_charts\//)
  ) {
    return 'Ideas';
  } else if (url.match(/\/bookmarks\/idea_boards\//)) {
    return 'Idea board';
  } else if (url.match(/\/polls\//)) {
    return 'Polls';
  } else if (url.match(/\/tasks\//)) {
    return 'To-dos';
  } else if (url.match(/\/pages/)) {
    return 'Notes';
  } else if (
    url.match(/\/custom_objects/) ||
    url.match(/\/custom_object_records/)
  ) {
    return 'Custom tables';
  } else if (
    url.match(/\/strategic_models/) ||
    url.match(/\/strategic_model_components/)
  ) {
    return 'Business models';
  } else if (url.match(/\/bookmarks\/gantt_charts/)) {
    return 'Releases Roadmap';
  } else if (url.match(/\/roadmap/)) {
    return 'Portfolio';
  } else if (url.match(/\/bookmarks\/project_timelines\//)) {
    return 'Feature roadmap';
  } else if (url.match(/\/bookmarks\/epic_timelines\//)) {
    return 'Epic roadmap';
  } else if (url.match(/\/bookmarks\/strategy_tables\//)) {
    return 'Hierarchy';
  } else if (url.match(/\/bookmarks\/strategy_trees\//)) {
    return 'Diagram';
  } else if (url.match(/\/bookmarks\/\w+_priority_lists/)) {
    return 'Priority list';
  } else if (url.match(/\/bookmarks\/release_retrospectives\//)) {
    return 'Release retrospective';
  } else if (
    url.match(/\/publish\/notebooks/) ||
    url.match(/\/reports\/saved\/notebooks/)
  ) {
    return 'Notebooks';
  } else if (
    url.match(/\/reports\/saved\//) ||
    url.match(/\/reports\/example/)
  ) {
    return 'Report dashboard';
  } else if (url.match(/\/how_aha_works/)) {
    return 'How Aha works';
  } else if (url.match(/\/bookmarks\/dependencies\//)) {
    return 'Dependency map';
  } else if (url.match(/\/bookmarks\/calendar_reports\//)) {
    return 'Calendar';
  } else if (url.match(/users\/\d+\/dashboards/)) {
    return 'My work';
  } else if (url.match(/\/audits/)) {
    return 'Activity';
    // This vision match should be last to ensure other strategy items are caught first
  } else if (
    url.match(/\/project_strategy_components/) ||
    url.match(/\/strategy/)
  ) {
    return 'Vision';
  } else if (url.match(/products\/\w+$/)) {
    return 'Product';
  } else if (url.match(/notifications/)) {
    return 'Notifications';
  } else if (url.match(/settings\/account\/billing\/upgrade/)) {
    return 'Billing > Upgrade options';
  } else if (url.match(/settings\/account\/billing/)) {
    return 'Billing > Current plans';
  } else if (url.match(/settings\/account\/users/)) {
    return 'Account users';
  } else if (url.match(/settings\/account\/profile/)) {
    return 'Account profile';
  } else if (url.match(/settings\/project_templates/)) {
    return 'Workspace templates';
  } else if (url.match(/settings\/projects\/\w+\/develop_configure/)) {
    return 'Workspace settings: Aha! Develop configuration';
  } else if (url.match(/settings\/projects\/\w+\/roadmaps_configure/)) {
    return 'Team settings: Aha! Roadmaps configuration';
  } else if (url.match(/settings\/projects\/\w+\/default_views/)) {
    return 'Workspace default views configuration';
  } else if (url.match(/settings\/account\/idea_portals/)) {
    return 'Portal settings';
  } else if (
    url.match(/promotion\/empathy_sessions/) ||
    url.match(/\/idea_sessions/)
  ) {
    return 'Empathy sessions';
  } else if (
    url.match(/promotion\/in_app_feedback/) ||
    url.match(/\/feedback_campaigns/)
  ) {
    return 'In app feedback';
  } else if (url.match(/promotion\/advanced_reporting/)) {
    return 'Advanced reporting';
  } else if (url.match(/\/program_increments/)) {
    return 'Program increments';
  } else if (url.match(/diagram_editor/)) {
    return 'Mockups';
  } else if (url.match(/\/bookmarks\/product_value_reports\//)) {
    return 'Product value report';
  } else if (url.match(/\/bookmarks\/opportunity_reports\//)) {
    return 'Salesforce opportunity report';
  } else if (url.match(/\/products\/[^/]+\/frameworks/)) {
    return 'Product development frameworks';
  } else if (url.match(/getting_started\/wizard/)) {
    return 'Getting started wizard';
  } else {
    if (window.railsEnv === 'development') {
      console.warn('urlToSection failed to find a name for this url');
    }
    return null;
  }
}
